import { motion } from "framer-motion";
import { EASE, useSafeInView } from "@/components/Reveal";

const NODES = [
  { x: 70, y: 60, label: "ERP" },
  { x: 200, y: 40, label: "CRM" },
  { x: 330, y: 80, label: "Data Lake" },
  { x: 110, y: 170, label: "Team" },
  { x: 250, y: 150, label: "Decision" },
  { x: 360, y: 200, label: "Workflow" },
  { x: 60, y: 270, label: "Owner" },
  { x: 190, y: 250, label: "System" },
  { x: 320, y: 290, label: "Signal" },
];

const EDGES = [
  [0, 1], [1, 2], [0, 3], [1, 4], [2, 5], [3, 4], [4, 5],
  [3, 6], [4, 7], [5, 8], [6, 7], [7, 8], [0, 4], [2, 4],
];

export default function GraphDiagram() {
  const [ref, show] = useSafeInView();
  return (
    <div ref={ref}>
      <svg viewBox="0 0 420 330" className="h-auto w-full" data-testid="diagram-context-graph">
        {EDGES.map(([a, b], i) => (
          <motion.line
            key={i}
            x1={NODES[a].x} y1={NODES[a].y}
            x2={NODES[b].x} y2={NODES[b].y}
            stroke="rgba(255,255,255,0.22)"
            strokeWidth="1"
            initial={{ pathLength: 0, opacity: 0 }}
            animate={show ? { pathLength: 1, opacity: 1 } : {}}
            transition={{ duration: 1.1, ease: EASE, delay: 0.15 + i * 0.05 }}
          />
        ))}
        {NODES.map((n, i) => (
          <motion.g
            key={i}
            initial={{ opacity: 0, scale: 0 }}
            animate={show ? { opacity: 1, scale: 1 } : {}}
            transition={{ duration: 0.7, ease: EASE, delay: i * 0.07 }}
            style={{ transformOrigin: `${n.x}px ${n.y}px` }}
          >
            <circle cx={n.x} cy={n.y} r="4" fill={i === 4 ? "#00C0C8" : "#FFFFFF"} />
            {i === 4 && <circle cx={n.x} cy={n.y} r="10" fill="none" stroke="#00C0C8" strokeOpacity="0.4" className="animate-pulse-soft" />}
            <text x={n.x + 10} y={n.y + 4} fill="rgba(255,255,255,0.45)" fontSize="10" fontFamily="'JetBrains Mono', monospace">
              {n.label}
            </text>
          </motion.g>
        ))}
      </svg>
    </div>
  );
}
